module.exports = __webpack_public_path__ + "static/media/telefono.88e66ae9.svg";